
import React, { useEffect, useRef } from 'react';
import { MonitorSmartphone } from 'lucide-react';

interface ParticipantScreenShareProps {
  isScreenSharing: boolean;
  isLocal: boolean;
  name: string;
  screenStream: MediaStream | null;
}

const ParticipantScreenShare: React.FC<ParticipantScreenShareProps> = ({ 
  isScreenSharing,
  isLocal,
  name,
  screenStream
}) => {
  const screenRef = useRef<HTMLVideoElement>(null);
  
  useEffect(() => {
    if (isLocal && isScreenSharing && screenStream && screenRef.current) {
      screenRef.current.srcObject = screenStream;
      console.log("Screen sharing initialized successfully");
    }
  }, [isLocal, isScreenSharing, screenStream]);
  
  if (!isScreenSharing) {
    return null;
  }
  
  return (
    <div className="absolute inset-0 bg-black flex items-center justify-center z-20">
      {isLocal && screenStream ? (
        <video 
          ref={screenRef}
          autoPlay 
          playsInline
          className="w-full h-full object-contain"
        />
      ) : (
        <div className="w-full h-full bg-gradient-to-r from-blue-900 to-indigo-900 flex items-center justify-center">
          <div className="text-center">
            <MonitorSmartphone className="w-12 h-12 mx-auto text-white/70 mb-2" />
            <p className="text-white">{name}'s Screen</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ParticipantScreenShare;
